import { render, staticRenderFns } from "./DataPermissionSidebar.vue?vue&type=template&id=0cdbd5d9&scoped=true&"
import script from "./DataPermissionSidebar.vue?vue&type=script&lang=js&"
export * from "./DataPermissionSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DataPermissionSidebar.vue?vue&type=style&index=0&id=0cdbd5d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdbd5d9",
  null
  
)

export default component.exports